
import { ReactNode } from "react";

interface FeatureItem {
  title: string;
  description: string;
  icon?: ReactNode;
}

interface ServiceFeaturesProps {
  features: FeatureItem[];
}

export const ServiceFeatures = ({ features }: ServiceFeaturesProps) => {
  return (
    <div className="py-12 bg-background">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8">Key Features</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="p-6 border rounded-lg shadow-sm bg-card hover:shadow-md transition-shadow"
            >
              {feature.icon && (
                <div className="mb-4 text-primary">
                  {feature.icon}
                </div>
              )}
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-muted-foreground">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export type { ServiceFeaturesProps, FeatureItem };
